/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedProductServiceList } from '../models/PaginatedProductServiceList';
import type { PatchedProductService } from '../models/PatchedProductService';
import type { ProductService } from '../models/ProductService';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ProductsServicesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedProductServiceList
     * @throws ApiError
     */
    public productsServicesList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedProductServiceList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-services/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns ProductService
     * @throws ApiError
     */
    public productsServicesCreate({
        requestBody,
    }: {
        requestBody: ProductService,
    }): CancelablePromise<ProductService> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/products-services/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductService
     * @throws ApiError
     */
    public productsServicesRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this product service.
         */
        id: number,
    }): CancelablePromise<ProductService> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/products-services/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProductService
     * @throws ApiError
     */
    public productsServicesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product service.
         */
        id: number,
        requestBody: ProductService,
    }): CancelablePromise<ProductService> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/products-services/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProductService
     * @throws ApiError
     */
    public productsServicesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this product service.
         */
        id: number,
        requestBody?: PatchedProductService,
    }): CancelablePromise<ProductService> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/products-services/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public productsServicesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this product service.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/products-services/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
